// Stats section content
export const stats = [
  {
    icon: 'icon-computer-screen-1',
    value: 5,
    label: 'AI Providers Supported'
  },
  {
    icon: 'icon-business-briefcase-cash',
    value: 10000,
    label: 'Presentations Generated'
  },
  {
    icon: 'icon-timer-4',
    value: 30,
    label: 'Seconds Avg Generation'
  },
  {
    icon: 'icon-rewards-medal-1',
    value: 99,
    label: '% API Uptime'
  }
]
